import { createSlice } from "@reduxjs/toolkit";
import { 
  addPhase, 
  deletePhase, 
  //getPhases, 
  updatePhase 
} from "./thunk";

interface PhaseStateType {
  phases: Array<any>;
  error?: string | object | null | undefined | unknown;
}
export const initialState: PhaseStateType = {
  phases: [],
  error: {},
};

const PhaseSlice = createSlice({
  name: "phases",
  initialState,
  reducers: {},
  extraReducers: builder => {
    /*builder.addCase(getPhases.fulfilled, (state: any, action: any) => {
      state.phases = action.payload;
    });
    builder.addCase(getPhases.rejected, (state, action) => {
      state.error = action.payload || null;
    });*/
    builder.addCase(addPhase.fulfilled, (state: any, action: any) => {
      state.phases.push(action.payload);
    });
    builder.addCase(addPhase.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updatePhase.fulfilled, (state: any, action: any) => {
      state.phases = state.phases.map((phase: any) =>
        phase.id === action.payload.id ? { ...phase, ...action.payload } : phase
      );
    });
    builder.addCase(updatePhase.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deletePhase.fulfilled, (state: any, action: any) => {
      state.phases = state.phases.filter(
        (phase: any) => phase.id !== action.payload
      );
    });
    builder.addCase(deletePhase.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export default PhaseSlice.reducer;
